export default "__VITE_ASSET__CccddGGT__"